@if (!loading && !successDrawId) {
  <div>
    <div mat-dialog-title class="draw-compliance-header">
      <div>
        <div class="compliance-container">
          <span class="text">Select lottoland draw</span><br />
          @if (selected) {
            <span class="subtext">Selected: {{ selected.lottolandId }}</span>
          }
        </div>
      </div>
      @if (selected) {
        <button mat-raised-button color="primary" (click)="createDraw()">Create</button>
      }
    </div>
    <div mat-dialog-content>
      <table mat-table [dataSource]="dataSource" class="data-table">
        @for (field of fields; track field) {
          <ng-container matColumnDef="{{ field.name }}">
            <th mat-header-cell *matHeaderCellDef>{{ field.label }}</th>
            <td mat-cell *matCellDef="let element">
              <app-table-cell [type]="field.type" [data]="element[field.name]" [fieldConfig]="field"></app-table-cell>
            </td>
          </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="fieldNames"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: fieldNames"
          (click)="onRowClick(row, $event)"
          class="maintain-row selectable"
          [ngClass]="getClassesForRow(row)"></tr>
      </table>
    </div>
  </div>
}
@if (!loading && successDrawId) {
  <div>
    <h3>
      <span>Draw successfully created with id = {{ successDrawId }}</span>
      <button mat-icon-button color="primary" (click)="goToNewDraw()"><mat-icon>search</mat-icon></button>
    </h3>
  </div>
}
@if (loading) {
  <mat-spinner></mat-spinner>
}
